<div class="flex items-center justify-center min-h-screen ">
    <!-- Coming Soon Box -->
    <div class="text-center bg-[#00000066] p-8 rounded-xl shadow-2xl w-96">
        <h1 class="text-4xl font-extrabold text-[#289dd2] mb-4">Coming Soon</h1>
        <p class="text-xl text-gray-400 mb-6">We're working hard to launch something amazing!</p>
    </div>
</div>
